import axios from 'axios';
import store from '../store';
export default {
    namespaced: true,

    state: {
        idmodal: '',
        descripcionmodal: '',
        banderamodal: null,
        categorias: [],
        categoria: []

    },
    mutations: {

        cambio(state, descripcion) {

            state.descripcionmodal = descripcion

        },

        LoadProductos(state, buscar) {
            //let aux = [];
            state.categoria = state.categorias;

            let aux = state.categorias.filter((x) => x["nombrecategoria"].toUpperCase().includes(buscar.toUpperCase()),);
            if (buscar == "") {
                state.categoria = state.categorias;
            } else {
                state.categoria = aux;

            }
        },


        async cargardatoscategorias(state) {

            state.categorias = []
            var token = store.state.numero;
            await axios
                .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                })
                .then((response) => {
                    state.categorias = response.data.data;

                }).catch((e) => {
                    console.log(e);
                    location.reload();
                });
            state.categoria = state.categorias
        },
        agregartable(state) {

            //      this.descripcionmodal = descripcion
            var token = store.state.numero;
            var datos = {
                nombrecategoria: state.descripcionmodal
            };
            this.banderamodal = store.state.banderamodal



            var datosfalso = state.idmodal;

            if (this.banderamodal === true) {


                axios

                    .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias", datos, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;

                    })

                    .catch((e) => {
                        console.log(e);
                        location.reload();
                    });
            } else {

                axios
                    .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias/UpdateReg/" +
                        datosfalso,
                        datos, {

                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    }
                    )
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;

                    })

                    .catch((e) => {
                        console.log(e);
                        location.reload();
                    });
            }

        },


        datosmodal(state, api) {

            state.idmodal = api.idcategoria,
                state.descripcionmodal = api.nombrecategoria

        },



        eliminar(state, api) {
            var token = store.state.numero
            let eliminar = api;

            axios
                .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias/DeleteReg/" + eliminar,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })


                .then((response) => {
                    let tokenn = response.data.token;
                    //this.respuesta = <z<
                    state.eliminer = tokenn;

                    //this.bandera = true;
                })

                .catch((e) => {
                    console.log(e);
                    location.reload();
                });



        },



    },
    actions: {

    },
    getters: {


    },






}